import { Container } from '@/components/layout/container';
import { Skeleton } from '@/components/ui/skeleton';

// Full-page placeholder shown while a lazy route chunk downloads.
// Matches the existing auth-loading skeleton language (h-96 rounded-xl)
// so the page transition feels consistent.
export const RouteFallback = () => (
  <Container size="lg" className="py-10">
    <Skeleton className="h-10 w-1/2 mb-4" />
    <Skeleton className="h-4 w-2/3 mb-8" />
    <Skeleton className="h-96 rounded-xl" />
  </Container>
);
